import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { Modal } from '@material-ui/core'
import { useStyles } from '../Styles/styles'
import PaginatedTableWrapper from './PaginatedTableWrapper';
import { UserContext } from '../Contexts/UserContext'
import { useLazyQuery } from '@apollo/client';
import { GET_INITIAL_CALL_INFO } from '../Queries/GetInitialCallInfo';
import { INCIDENT_ACTIONS } from '../Actions/IncidentActions';
import { IncidentsContext } from '../Contexts/IncidentsContext'
import { parseAddressHistory, addressHistoryHeaders } from '../utils/AddressHistoryHelper';
import { ADDRESS_HISTORY } from '../Queries/AddressHistory';
import { localGetData, localStoreData } from '../utils/utils';


const AddressHistoryModal = ({ modalOpen, setModalOpen, address }) => {
  const classes = useStyles();
  const { user, responseErrorHandler } = useContext(UserContext);
  const { incidentDispatch, incidents, setFocusTab } = useContext(IncidentsContext)
  const { SET_INITIAL_CALL_INFO } = INCIDENT_ACTIONS;
  const tabWrapperRef = useRef(null)

  const [dashSize, setDashSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })

  useEffect(() => {
    if (modalOpen && tabWrapperRef?.current?.offsetHeight) {
      setDashSize({
        width: tabWrapperRef.current.offsetWidth,
        height: tabWrapperRef.current.offsetHeight,
      });
    }
  }, [modalOpen])

  useEffect(() => {
    function handleResize() {
      tabWrapperRef.current && setDashSize({
        width: tabWrapperRef.current.offsetWidth,
        height: tabWrapperRef.current.offsetHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [getCallInfo] = useLazyQuery(GET_INITIAL_CALL_INFO, {
    context: { serializationKey: "incidentQueue" },
    variables: { originatorId: user?.id },
    fetchPolicy: "network-only",
    onError: (error) => {
      console.error(JSON.stringify(error))
    },
    onCompleted: (data) => {
      if (data) {
        responseErrorHandler(data)
        incidentDispatch({ type: SET_INITIAL_CALL_INFO, payload: data })
        handleIncidentOpening(data.initialCallInfo.id)
      }

    }
  })
  const handleIncidentOpening = useCallback((incidentId) => {
    let index = incidents.findIndex(i => i.id === incidentId || i.uuid === incidentId)
    if (index > -1) {
      setFocusTab(index + 4)
    } else {
      getCallInfo({ variables: { incidentId: incidentId } })
      let openIncidents = localGetData(`${user?.id}-open-incidents`) || []
      if (!openIncidents.includes(incidentId) && incidentId) {
        openIncidents.push(incidentId)
        localStoreData(openIncidents, `${user?.id}-open-incidents`)
      }
    }
  }, [getCallInfo, incidents, setFocusTab, user?.id])

  // History fetching logic
  const [addressHistory, { loading: addressHistoryLoading, data: addressHistoryData }] = useLazyQuery(ADDRESS_HISTORY, {
    context: { serializationKey: "incidentQueue" },
    fetchPolicy: "network-only",
  })

  useEffect(() => {
    if (modalOpen) {
      addressHistory({ variables: { addressId: address?.id, originatorId: user?.id } })
    }
  }, [address?.id, addressHistory, modalOpen, user?.id])



  return (
    <Modal
      // disableEnforceFocus
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      className={classes.modal}
      data-cy="address-history-modal"
      keepMounted={false}
    >
      <div id={"tabs-wrapper"} style={{ height: '75vh', maxWidth: '75vw' }} className={classes.tabRoot} ref={tabWrapperRef}>
        <PaginatedTableWrapper
          dashSize={dashSize}
          dashWidthPercentage={.75}
          tableHeight={dashSize?.height}
          tableName={"Address Incident History"}
          headers={addressHistoryHeaders}
          userId={user?.id}
          paginatedQueryHandler={() => console.log('Not paginated')}
          rows={addressHistoryData ? parseAddressHistory(addressHistoryData[Object.keys(addressHistoryData)[0]], handleIncidentOpening, user?.roleNames) : []}
          loading={addressHistoryLoading}
          error={null}
          paginated={false}
          resizable={false}
        />
      </div>
    </Modal>
  );
}

export default AddressHistoryModal;